const GRAY = {
  25: '#FBFBFB',
  50: '#F7F7F7',
  100: '#F3F3F3',
  200: '#EEEEEE',
  300: '#E6E6E6',
  400: '#DBDBDB',
  500: '#CBCBCB',
  600: '#B5B5B5',
  700: '#959595',
  800: '#686868',
  900: '#272727',
}

const BLUE = {
  50: '#F1F2FF',
  100: '#E4E7FE',
  200: '#C9CEFD',
  300: '#9BA6FC',
  400: '#6E7DFA',
  500: '#4A5DF9',
  600: '#3B4AC7',
  700: '#2C3895',
  800: '#1E2564',
  900: '#0F1332',
}
const ORANGE = {
  50: '#FFEDE0',
  100: '#FFE1CB',
  200: '#FFCBA5',
  300: '#FFA15C',
  400: '#FF8A33',
  500: '#FF6D00',
  600: '#CC5700',
  700: '#994100',
  800: '#662C00',
  900: '#331600',
}
const RED = {
  50: '#FFF2F6',
  100: '#FFE5ED',
  200: '#FFCCDB',
  300: '#FF6692',
  400: '#FF336E',
  500: '#FF004A',
  600: '#CC003B',
  700: '#99002C',
  800: '#66001E',
  900: '#33000F',
}
const YELLOW = {
  50: '#FFF7E5',
  100: '#FFF0CC',
  200: '#FFE099',
  300: '#FFD166',
  400: '#FFC133',
  500: '#FFB200',
  600: '#CC8E00',
  700: '#996B00',
  800: '#664700',
  900: '#332400',
}
const GREEN = {
  50: '#E9F9EE',
  100: '#D3F3DE',
  200: '#A7E8BD',
  300: '#7ADC9B',
  400: '#4ED17A',
  500: '#22C559',
  600: '#1B9E47',
  700: '#147635',
  800: '#0E4F24',
  900: '#072712',
}
const CYAN = {
  50: '#EBF9FD',
  100: '#D7F5FD',
  200: '#C0EEFB',
  300: '#6AD7F5',
  400: '#39CAF2',
  500: '#00BFF3',
  600: '#0697BF',
  700: '#04718F',
  800: '#034C60',
  900: '#012630',
}
const PURPLE = {
  50: '#F5F3FF',
  100: '#EDE9FE',
  200: '#DDD6FE',
  300: '#C4B5FD',
  400: '#A78BFA',
  500: '#8B5CF6',
  600: '#7C3AED',
  700: '#6D28D9',
  800: '#5B21B6',
  900: '#4C1D95',
}

export const colors = {
  primary: BLUE,
  secondary: GRAY,
  success: GREEN,
  critical: RED,
  warning: ORANGE,
  caution: YELLOW,
  info: BLUE,
  blue: BLUE,
  red: RED,
  gray: GRAY,
  green: GREEN,
  orange: ORANGE,
  yellow: YELLOW,
  cyan: CYAN,
  purple: PURPLE,
}

export type Color = keyof typeof colors
